import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../SectionChapter';

const ShowIndividualBoards = ({ language,refs }) => {
    let boardMenu = [
        {
            id: 'tutorial.manageSplitBoardLesson.mainDisplay.description',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageSplitBoardLesson.mainDisplay.explanation1"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageSplitBoardLesson.mainDisplay.explanation2"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageSplitBoardLesson.mainDisplay.explanation3"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [`/static/asset/img/tutorial/withText/${language.toUpperCase()}/lessonPage_multiBoardMain.jpeg`],
        },
    ];
    return (
        <SectionChapter
            refs={refs}
            id={'section-manageSplitBoardLesson-mainDisplay'}
            title={'tutorial.manageSplitBoardLesson.mainDisplay.title'}
            explanations={boardMenu}
            imageTop={false}
        />
    );
};

export default ShowIndividualBoards;
